import React, { forwardRef, useState, ReactElement } from 'react';
import classNames from "classnames";
import styled from "styled-components";
import IBuildrProps from '../../../utilities/IBuildrProps';
import { IInputRadioProps } from '../InputRadio';
import { IInputCheckboxProps } from '../InputCheckbox';

export interface IInputGroupProps extends IBuildrProps {
    title: string;
    groupClassName: string;
    groupName?: string;
    groupRequired?: boolean;
    errorMessage: string;
    children: ReactElement<IInputRadioProps|IInputCheckboxProps>;
    isWhite: boolean;
}

export default styled(forwardRef(function InputGroup({ title, groupClassName, errorMessage, groupName, groupRequired, children, className, cmsId, editorClassObj, isWhite }: IInputGroupProps, ref: any) {
    const isInputWhite = (groupClassName && groupClassName.includes('text-white')) || isWhite;
    const [checkedOptions, setCheckedOptions] = useState<Record<string, boolean>>({});
    const hasCheckedOption = Object.values(checkedOptions).some(option => Boolean(option));

    return (
        <div className={classNames(className, groupClassName, editorClassObj)} data-id={cmsId}>
            {title &&
                <div className="row no-gutters">
                    <div className="col-12">
                        <h5 className={classNames('title', {'text-white': isWhite})}>{title}</h5>
                    </div>
                </div>
            }

            <div className="row no-gutters">
                {React.Children.map(children,
                    (child: ReactElement<IInputRadioProps|IInputCheckboxProps>) => {
                        return React.cloneElement(child, {
                            groupName,
                            groupRequired: groupRequired && !hasCheckedOption,
                            isWhite: isInputWhite,
                            errorMessage,
                            checkedOptions,
                            onChange: (name, checked) => setCheckedOptions((options) =>  ({...options, [name]: checked}))
                        });
                    })
                }
            </div>
        </div>
    )
}))`
.title {
    font-size: 0.889rem;
    font-weight: 500;
    line-height: 1rem;
    margin-bottom: 1.333rem;
}`;
